import SearchIcon from '@img/icons/search.svg';
import React, { useCallback, useMemo } from 'react';
import DesktopNavigationLink from '../DesktopNavigationLink/DesktopNavigationLink';
import S from './DesktopNavigation.styles';
const DesktopNavigation = ({ items, reduced = false, onSearchToggle, isSearchActive, }) => {
    const [activeItemId, setActiveItemId] = React.useState(null);
    const onSearchClick = useCallback((event) => {
        event.preventDefault();
        onSearchToggle();
    }, [onSearchToggle]);
    const searchLabel = useMemo(() => (isSearchActive ? 'Close Search' : 'Open Search'), [isSearchActive]);
    return (React.createElement(S.Container, { "aria-label": "Main Navigation - Desktop" },
        React.createElement(S.ItemList, null,
            items.map((item) => (React.createElement(DesktopNavigationLink, { key: item.id, item: item, isActive: activeItemId === item.id, setActiveItemId: setActiveItemId }))),
            !reduced && (React.createElement(S.Item, null,
                React.createElement(S.SearchIconLink, { as: "button", "aria-label": searchLabel, title: searchLabel, onClick: onSearchClick },
                    React.createElement(SearchIcon, null)))))));
};
export default DesktopNavigation;
